import { useEffect, useState } from "react";
import Navbar from "./Navbar";
import Footer from "./Footer";
import CookiesConsentPopup from "./CookiesConsentPopup";
import SEODebug from "./SEODebug";
interface LayoutProps {
  children: React.ReactNode;
  isCalendarOpen: boolean;
  setIsCalendarOpen: (isOpen: boolean) => void;
}

const Layout = ({ children, isCalendarOpen, setIsCalendarOpen }: LayoutProps) => {
  const [isCookiesPopupVisible, setIsCookiesPopupVisible] = useState(false);

  useEffect(() => {
    // Check if the user has already accepted cookies
    const userAcceptCookies = localStorage.getItem("userAcceptCookies");

    if (!userAcceptCookies) {
      // Show the cookies popup if the user hasn't accepted cookies
      setIsCookiesPopupVisible(true);
    }
  }, []);

  const handleCloseCookiesPopup = () => {
    setIsCookiesPopupVisible(false);
  };
  return (
    <div className="min-h-screen bg-white flex flex-col">
      <Navbar isCalendarOpen={isCalendarOpen} setIsCalendarOpen={setIsCalendarOpen} />
      <main className="flex-grow">{children}</main>
      {isCookiesPopupVisible && (
        <CookiesConsentPopup onClose={handleCloseCookiesPopup} />
      )}
      <Footer />
      {/* {process.env.NODE_ENV !== 'production' && <SEODebug />} */}
    </div>
  );
};

export default Layout;
